const BusinessCalculatorDescribed = () => {
  return (
    <div className="mt-2 container narrow text-center">
      <div className="h1 mt-2 mb-1 text-primary" style={{fontSize: "3rem"}}>RETURN ON INVESTMENT CALCULATOR</div>
    </div>
  );
};

export default BusinessCalculatorDescribed;
